import { Component, OnInit } from '@angular/core';
import { PlayerService } from '../player.service';
import {environment} from '../../environments/environment';


@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss']
})
export class LoadingOverlayComponent implements OnInit {

  init:boolean = true;
  _start:boolean = false;
  comming_soon:boolean = false;
  icy_metadata:string = "";
  title:string = "";
  startApp:boolean = false;

  constructor(
    public playerService:PlayerService,
  ) {

    /* subscribe to app init */
    playerService.init_app$
    .subscribe(
      (res:boolean) => { this.comming_soon = res; }
    )

    /* subscribe to metada info */
    playerService.icy_metadata$
    .subscribe(
      (res:string) => { this.icy_metadata=res;}
    )

    /* subscribe to post info */
    playerService.podcast$
    .subscribe(
      (post) => { this.title = post[0].title.rendered }
    )

  }

  ngOnInit() {
    // this.playerService.play("https://brba.audio-lab.org/stream/brba.mp3");
  }

  play() {
    this.playerService.play(environment.urlStream);
    // this.comming_soon=true;
    this.startApp = true;
    /* WORKING PROGRESS: STOP AQUÍ */
    //return;
    this.init=!this.init;
  }

  start() {
    // console.log("load")
    if (this._start) return;
    this._start = true;
    // this.playerService.play("https://stream.audio-lab.org/brba.mp3");
  }


}
